module.exports = __webpack_public_path__ + "static/media/send.3955195d.svg";